export default "__VITE_ASSET__9cac643a__"